// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2n3pj","upload":"Small_upload__MUlPP","imageWrap":"Small_imageWrap__1Q_h_","removeBtn":"Small_removeBtn__CAYZC"};